import { Validator } from '@vista-digital/validator';
import { BookingFeeMode, bookingFeeModeValidator } from './booking-fee-mode';
import { TaxMode, taxModeValidator } from './tax-mode';
import { TicketingMode, ticketingModeValidator } from './ticketing-mode';
import { defaultOrderTipConfig, orderTipConfigValidator } from './tip';
export const defaultOrderConfig = {
    bookingFeeMode: BookingFeeMode.Inclusive,
    taxMode: TaxMode.Inclusive,
    ticketingMode: TicketingMode.TicketFirst,
    maximumTicketsPerOrder: 20,
    maximumItemsPerOrder: 99,
    maximumModifiersPerItem: 99,
    redemptionExpiringSoonDurationInDays: 90,
    admittingDuration: 1,
    unpaidBookingCutoffTime: 0,
    isBookingFeeApplicableToUnpaidBookings: false,
    tip: defaultOrderTipConfig,
    autofillMemberDetails: true,
    autofillMemberTaxDetails: false
};
export const orderConfigValidator = Validator.object({
    bookingFeeMode: bookingFeeModeValidator,
    taxMode: taxModeValidator,
    ticketingMode: ticketingModeValidator,
    maximumTicketsPerOrder: Validator.number({ min: 1 }),
    maximumItemsPerOrder: Validator.number({ min: 1 }),
    maximumModifiersPerItem: Validator.number({ min: 1 }),
    redemptionExpiringSoonDurationInDays: Validator.number({ min: 0 }),
    admittingDuration: Validator.number({ min: 0 }),
    unpaidBookingCutoffTime: Validator.number({ min: 0 }),
    isBookingFeeApplicableToUnpaidBookings: Validator.boolean(),
    tip: orderTipConfigValidator,
    autofillMemberDetails: Validator.boolean(),
    autofillMemberTaxDetails: Validator.boolean()
});
//# sourceMappingURL=order.js.map